module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "frontmatter",
      "id": "ser"
    }
  }, [_c('p', {
    staticClass: "sert"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "ii",
      "id": "pii",
      "role": "doc-pagebreak"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "100",
      "src": "images/logo-chicago-guides.jpg",
      "width": "147"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Digital Paper")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Andrew Abbott")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Telling About Society")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Howard S. Becker")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Tricks of the Trade")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Howard S. Becker")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Writing Your Journal Article in Twelve Weeks")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Wendy Laura Belcher")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("The Craft of Research")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Wayne C. Booth, Gregory G. Colomb, Joseph M. Williams, Joseph Bizup, and William T. FitzGerald")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("From Dissertation to Book")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("William Germano")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Getting It Published")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("William Germano")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("From Notes to Narrative")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Kristen Ghodsee")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Thinking Like a Political Scientist")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Christopher Howard")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Write No Matter What")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Joli Jensen")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("How to Write a BA Thesis")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Charles Lipson")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Economical Writing")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Deirdre Nansen McCloskey")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("The Chicago Guide to Writing about Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Jane E. Miller")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Going Public")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Arlene Stein and Jessie Daniels")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("The Writer’s Diet")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Helen Sword")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("A Manual for Writers of Research Papers, Theses, and Dissertations")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Kate L. Turabian")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Student’s Guide to Writing College Papers")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Kate L. Turabian")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-052f26ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-becker-0003.vue
// module id = 60
// module chunks = 0